/**
 * Size Guide Width Calculator
 * 
 * This script calculates the width of the Product__InfoWrapper element
 * and applies it to the .js-size-guide element so that when the size guide
 * is opened, it only covers the Product__InfoWrapper area, keeping the
 * Product__Gallery visible.
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    selectors: {
      sizeGuide: '.js-size-guide',
      infoWrapper: '.Product__InfoWrapper',
      sizeGuideTrigger: '.js-size-guide-trigger'
    },
    debounceDelay: 250
  };

  // Debounce function to limit how often resize calculations run
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Calculate and set the size guide width
  function setSizeGuideWidth() {
    const sizeGuide = document.querySelector(CONFIG.selectors.sizeGuide);
    const infoWrapper = document.querySelector(CONFIG.selectors.infoWrapper);

    if (!sizeGuide || !infoWrapper) {
      console.warn('Size guide or info wrapper element not found');
      return;
    }

    // Get the bounding rectangle of the info wrapper
    const infoWrapperRect = infoWrapper.getBoundingClientRect();
    
    // Calculate width from the left edge of info wrapper to the right edge of viewport
    // This includes the right gap caused by the container's max-width
    const viewportWidth = window.innerWidth;
    const widthFromInfoWrapperToViewportEdge = viewportWidth - infoWrapperRect.left;
    
    // Apply the width and position to the size guide
    sizeGuide.style.width = `${widthFromInfoWrapperToViewportEdge}px`;
    sizeGuide.style.maxWidth = `${widthFromInfoWrapperToViewportEdge}px`;
    
    // Position the size guide to align with the info wrapper's left edge
    // and extend to the viewport's right edge
    sizeGuide.style.left = `${infoWrapperRect.left}px`;
    sizeGuide.style.right = '0';
  }

  // Initialize the calculator
  function init() {
    const sizeGuide = document.querySelector(CONFIG.selectors.sizeGuide);
    const sizeGuideTriggers = document.querySelectorAll(CONFIG.selectors.sizeGuideTrigger);

    if (!sizeGuide) {
      console.warn('Size guide element not found, skipping initialization');
      return;
    }

    // Set initial width
    setSizeGuideWidth();

    // Recalculate on window resize (debounced)
    const debouncedResize = debounce(setSizeGuideWidth, CONFIG.debounceDelay);
    window.addEventListener('resize', debouncedResize);

    // Recalculate when size guide is opened
    if (sizeGuideTriggers.length > 0) {
      sizeGuideTriggers.forEach(function(sizeGuideTrigger) {
        sizeGuideTrigger.addEventListener('click', function() {
          // Small delay to ensure the size guide is visible before calculating
          setTimeout(setSizeGuideWidth, 50);
        });
      });
    }

    // Listen for mutation observer in case the DOM changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'class' &&
            mutation.target.classList.contains('js-size-guide')) {
          setSizeGuideWidth();
        }
      });
    });

    observer.observe(sizeGuide, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
